import { StepCollapseLabel } from './StepCollapseLabel';

const STEP_SPACING = 24;

export const getStepCollapseItem = ({ step, currentStep, icon, title, primaryColor, children }) => {
  const isActive = currentStep === step;
  const isCompleted = currentStep > step;
  const isPending = currentStep < step;

  return {
    key: step,
    label: (
      <StepCollapseLabel
        step={step}
        icon={icon}
        title={title}
        primaryColor={primaryColor}
        isActive={isActive}
        isCompleted={isCompleted}
      />
    ),
    children,
    style: {
      marginBottom: STEP_SPACING,
      borderRadius: 8,
      border: 'none',
      ...(isPending && {
        display: 'none', // Se ocultan los pasos pendientes
      }),
    },
    styles: {
      header: {
        borderRadius: 'inherit',
        ...(isActive && {
          backgroundColor: primaryColor,
          color: '#ffffff',
        }),
        ...(isCompleted && {
          backgroundColor: `${primaryColor}1a`,
          color: primaryColor,
          border: `1px solid ${primaryColor}33`,
        }),
      },
      body: {
        padding: `${STEP_SPACING}px 0 0 0`,
      },
    },
  };
};